import React, {
  Fragment,
  useRef,
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@cotyorg/ccx-atoms/Button';
import ProductSwatchColoursItemMarkup from './ProductSwatchColoursItemMarkup';
import ProductSwatchSelection from '../ProductSwatchSelection';

const generateBtnClassNames = ({ isOpen }) => classNames(
  'product-radio-wrapper',
  {
    'product-radio-wrapper--is-open': isOpen,
  },
);

const ProductSwatchColours = ({
  swatches,
  setProductSKU,
  selectedSKU,
  toggleAllShades,
  label,
  toggleMoreLabel,
  labelFirst,
  nameFirst,
  separator,
  onChange,
  isOpen,
  currentBreakpoint,
  testAttribute,
}) => {
  const swatchWrapperEl = useRef(null);
  const [swatchOverflowing, setSwatchOverflowing] = useState(false);

  useEffect(() => {
    if (swatchWrapperEl.current) {
      const { clientHeight, scrollHeight } = swatchWrapperEl.current;
      setSwatchOverflowing(clientHeight < scrollHeight);
    }
  }, [currentBreakpoint]);

  return (
    <Fragment>
      <ProductSwatchSelection
        label={label}
        labelFirst={labelFirst}
        nameFirst={nameFirst}
        separator={separator}
      />
      <div className={generateBtnClassNames({ isOpen })} >
        <ProductSwatchColoursItemMarkup
          ref={swatchWrapperEl}
          swatches={swatches}
          setProductSKU={setProductSKU}
          selectedSKU={selectedSKU}
          onChange={onChange}
          testAttribute={testAttribute}
        />
      </div>
      {swatchOverflowing &&
        <Button
          onClick={toggleAllShades}
          extraClass="product-swatch-colors-show-more"
        >
          {toggleMoreLabel}
        </Button>
      }
    </Fragment>
  );
};

ProductSwatchColours.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    // TODO: [2] define proper shape structure for swatch object
    skuColor: PropTypes.string,
    sku: PropTypes.string,
  })).isRequired,
  setProductSKU: PropTypes.func,
  selectedSKU: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelFirst: PropTypes.bool,
  nameFirst: PropTypes.bool,
  separator: PropTypes.string,
  onChange: PropTypes.func,
  toggleAllShades: PropTypes.func,
  toggleMoreLabel: PropTypes.string,
  isOpen: PropTypes.bool,
  currentBreakpoint: PropTypes.string,
  testAttribute: PropTypes.string,
};

export default ProductSwatchColours;
